import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import InformationIcon from 'assets/icons/information-icon.svg';
import WarningIcon from 'assets/icons/exclamation.svg';
import SuccessIcon from 'assets/icons/success-icon.svg';

import * as S from './styles';

const Overlay = ({ type, isOpen, children, text }) => {
  const [overlayType, setOverlayType] = useState('');
  const [icon, setIcon] = useState('');

  useEffect(() => {
    const changeOverlayType = value => {
      switch (value) {
        case 'information':
          setOverlayType('information');
          setIcon(InformationIcon);
          break;
        case 'warning':
          setOverlayType('warning');
          setIcon(WarningIcon);
          break;
        case 'success':
          setOverlayType('success');
          setIcon(SuccessIcon);
          break;
        default:
          return '';
      }
    };
    changeOverlayType(type);
  }, [type]);

  return (
    <S.Container modalVisibility={isOpen}>
      <S.Overlay>
        <S.OverlayIcon src={icon} />
        <S.OverlayText className={`overlay-${overlayType}-text`}>
          {text}
        </S.OverlayText>
        <S.OverlayButtons className={`overlay-${overlayType}-buttons`}>
          {children}
        </S.OverlayButtons>
      </S.Overlay>
    </S.Container>
  );
};

export default Overlay;

Overlay.defaultProps = {
  isOpen: false,
};

Overlay.propTypes = {
  type: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
